<template>
  <v-card class="mb-6">
    <div class="post-header pa-4">
      <div class="post-author-info d-flex">
        <v-avatar v-if="item.profile_image" size="48"
          ><img :src="item.profile_image"
        /></v-avatar>
        <v-avatar v-else size="48"
          ><img src="/images/default-profile.jpg"
        /></v-avatar>
        <div class="detail ml-4">
          <h4>{{ item.name }}</h4>
          <small>
            <v-chip
              v-for="type of item.creator_type"
              x-small
              class="mr-1"
              :key="type"
              >{{ type }}</v-chip
            >
          </small>
        </div>
      </div>
      <div class="ml-auto">
        <time>{{ moment(item.datetime.toDate()).fromNow() }}</time>
      </div>
    </div>

    <div class="post-body pa-4">
      <h3 class="ma-0" v-if="item.title">
        {{ item.title }}
      </h3>
      <small>{{ item.event_date }}</small>
      <img
        v-if="item.media && item.media_type == 'image'"
        :class="{ 'my-4': item.type != 'media' }"
        :src="item.media"
        style="width: 100%"
      />
      <iframe
        v-if="item.media && item.media_type == 'video'"
        :class="{ 'my-4': item.type != 'media' }"
        :src="item.media"
        style="width: 100%"
      />
      <p class="ma-0" v-if="item.description || item.thought">
        {{ item.description || item.thought }}
      </p>
      <v-chip-group v-if="item.genre">
        <v-chip v-for="(genre, k) of item.genre" :key="k">{{ genre }}</v-chip>
      </v-chip-group>
    </div>
    <div class="post-footer">
      <div class="d-flex align-center px-2 py-4">
        <div class="d-flex align-center">
          <i
            v-if="item.likes && item.likes.find((like) => like == authUser.id)"
            class="fa fa-heart mr-2"
            style="cursor: pointer"
            @click="(e) => addPostLike({ post_id: item.id, by: authUser.id })"
          ></i
          ><i
            v-else
            class="fa fa-heart-o mr-2"
            style="cursor: pointer"
            @click="(e) => addLike({ post_id: item.id, by: authUser.id })"
          ></i
          >{{ item.likes && item.likes.length }}
        </div>
        <div class="d-flex align-center ml-4">
          <i class="fa fa-comment mr-2"></i>{{ item.comments.length }}
        </div>
      </div>
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header> Comments </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div v-for="(comment, k) of item.comments" :key="k" class="comment">
              <div class="d-flex mb-3" style="align-items: center">
                <v-avatar v-if="item.profile_image" class="mr-3"
                  ><img :src="item.profile_image"
                /></v-avatar>
                <v-avatar v-else class="mr-3"
                  ><img src="/images/default-profile.jpg"
                /></v-avatar>
                <div>
                  <div>
                    {{ comment.comment_by }}
                  </div>
                  <small> @{{ comment.username }} </small>
                </div>
                <time class="ml-auto">{{
                  moment(comment.datetime.toDate()).fromNow()
                }}</time>
              </div>
              {{ comment.comment }}
            </div>
            <div class="buttons px-2 py-4">
              <v-form
                @submit="(e) => lc_add_comment(e, item.id)"
                :ref="`ref${item.id}`"
              >
                <comment
                  :comments="comments"
                  :onChange="
                    (data) => {
                      comments[item.id] = data;
                    }
                  "
                />
                <v-btn type="submit" block class="mb-4" color="primary"
                  >Add</v-btn
                >
              </v-form>
              <!-- <v-btn class="mr-3" small>Awesome</v-btn>
        <v-btn class="mr-3" small>Whats it about?</v-btn>
        <v-btn small>Oooo Great Wow.</v-btn> -->
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </v-card>
</template>

<script>
import moment from "moment";
import Comment from "./comment.vue";
export default {
  props: ["item", "addComment", "addLike"],
  components: {
    Comment,
  },
  mounted() {},
  data() {
    return {
      comments: {},
      text: "",
      items: [],
    };
  },

  methods: {
    moment,
    async lc_add_comment(e, post_id) {
      e.preventDefault();

      let uid = this.authUser.id;
      let validate = this.$refs[`ref${post_id}`].validate();
      if (validate) {
        let comment = this.comments[post_id];
        this.addComment({ comment_by: uid, comment, post_id });
        this.$refs[`ref${post_id}`].reset();
      }
    },
  },
};
</script>

<style>
.post-header {
  display: flex;
  align-items: center;
  height: 70px;
}
.post-body {
  border-top: 1px solid rgba(0, 0, 0, 0.4);
  border-bottom: 1px solid rgba(0, 0, 0, 0.4);
}
.buttons {
  border-top: 1px solid rgba(0, 0, 0, 0.4);
}
.comment {
  border: 1px solid rgba(0, 0, 0, 0.4);
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
}
</style>
